'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCompletedDynamicEvents = exports.createDynamicEvent = undefined;
exports.dynamicEventHelper = dynamicEventHelper;

var _constants = require('./constants');

var _performanceEntryUtils = require('./performanceEntryUtils');

/* eslint-disable no-console */

var createDynamicEvent = exports.createDynamicEvent = function createDynamicEvent() {
    return new CustomEvent(_constants.DYNAMIC_EVENT_END_NAME, {
        bubbles: _constants.DYNAMIC_EVENT_BUBBLES,
        cancelable: _constants.DYNAMIC_EVENT_CANCELABLE
    });
};

/**
 * Clear completed performance entries from Performance API
 * @param {PerformanceEntry[]} entries
 */
var getCompletedDynamicEvents = exports.getCompletedDynamicEvents = function getCompletedDynamicEvents() {
    var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var completedEntries = entries.filter(function (entry) {
        return _constants.DYNAMIC_EVENT_END_SUFFIXES_REGEX.test(entry.name);
    });
    var startEntries = completedEntries.map(function (completedEntry) {
        var name = completedEntry.name;

        var startEventName = name.replace(_constants.DYNAMIC_EVENT_END_SUFFIXES_REGEX, '');
        return (0, _performanceEntryUtils.getPerformanceEntriesByName)(startEventName)[0];
    }).filter(function (entry) {
        return entry !== undefined;
    });
    return [].concat(startEntries, completedEntries);
};

// including dynamic event start, end, failed
function dynamicEventHelper(eventName, didEnd, callback) {
    var _window = window,
        dispatchEvent = _window.dispatchEvent,
        performance = _window.performance;

    var performanceEntries = [];
    var hasBeginMark = performance.getEntriesByName(eventName, 'mark').length;

    if (!hasBeginMark) {
        return;
    }

    if (didEnd) {
        var endEventName = '' + eventName + _constants.DYNAMIC_EVENT_END_SUFFIX;
        var durationEventName = '' + eventName + _constants.DYNAMIC_EVENT_DURATION_SUFFIX;
        performance.mark(endEventName);
        performance.measure(durationEventName, eventName, endEventName);
        performanceEntries.push(durationEventName);
        performance.clearMarks(endEventName);
    } else {
        var failedEventName = '' + eventName + _constants.DYNAMIC_EVENT_FAILED_SUFFIX;
        performanceEntries.push(failedEventName);
        performance.mark(failedEventName);
    }
    window.ghghg = 'cvccvcv';

    if (callback) {
        callback(performanceEntries);
    }

    // Pass all performance entries to event
    dispatchEvent(createDynamicEvent());
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/dynamicEventHelper.js
// module id = 512
// module chunks = 5